module.exports = __webpack_public_path__ + "static/media/test_sonar.e0d1eb41.jpg";